import React, { useContext, useEffect, useState } from "react";
import { Button, Menu, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PartSalesServices from "lib/services/api/commercial/parts";
import { ToastMessageContext } from "lib/contexts/message_context";

// Custom styles for each status
const useStyles = makeStyles({
    button: {
        height: "30px",
        borderRadius: "5px",
        textTransform: "uppercase",
        minWidth: "97px",
        fontSize: "14px",

    },
    green: {
        backgroundColor: "transparent",
        color: "#4CAF50",
        border: "1px solid #4CAF50",
        textDecorationColor: "#4CAF50"

    },
    amber: {
        backgroundColor: "transparent",
        color: "#FFA726",
        border: "1px solid #FFA726",
        textDecorationColor: "#FFA726"
    },
    red: {
        backgroundColor: "transparent",
        color: "#F44336",
        border: "1px solid #F44336",
        textDecorationColor: "#F44336"
    },
    grey: {
        backgroundColor: "transparent",
        color: "#4D4F5C",
        border: "1px solid #4D4F5C",
        textDecorationColor: "#4D4F5C"
    },

});

// Status component
const StatusButton = (props) => {
    const classes = useStyles();
    const { status,
        due_date,
        setAction,
        setCurrentSelection,
        rowDetails,
        type,
        getDetails,
        paid,
        headerDetails, writePermission, rowType } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const message = useContext(ToastMessageContext)

    // Get current date for comparison
    const now = new Date();
    const isCompleteRed = ["complete"].includes(status) && rowDetails?.number_status === 6
    const isCompleteGreen = ["complete"].includes(status) && rowDetails?.number_status === 3
    const isEditable = rowDetails?.highest_row && ["complete", "rejected", "cancelled", "repair", "pending", "overdue", "complete_red"].includes(status) && paid === false && writePermission


    // Determine status and style
    const getStatusDetails = () => {
        switch (status) {
            case 0:
                return { label: "QUOTE", style: classes.green };
            case 1:
                if (new Date(due_date) >= now) {
                    return { label: "PENDING", style: classes.amber };
                } else {
                    return { label: "OVERDUE", style: classes.red };
                }
            case 2:
                return { label: "REPAIR", style: classes.grey };
            case 3:
                return { label: "COMPLETE", style: classes.green };
            case 4:
                return { label: "REJECTED", style: classes.red };
            case 5:
                return { label: "CANCELLED", style: classes.red };
            case 6:
                return { label: "COMPLETE", style: classes.red };

        }
    };  // Determine status and style
    const getSubStatusDetails = () => {
        switch (status) {
            case "quote":
                return { label: "QUOTE", style: classes.green };
            case "pending":

                return { label: "PENDING", style: classes.amber };
            case "overdue":
                return { label: "OVERDUE", style: classes.red };

            case "repair":

                return { label: "REPAIR", style: classes.grey };
            case "complete":
                if (isCompleteGreen) {
                    return { label: "COMPLETE", style: classes.green };
                } else {
                    return { label: "COMPLETE", style: classes.red };
                }


            case "rejected":
                return { label: "REJECTED", style: classes.red };
            case "cancelled":
                return { label: "CANCELLED", style: classes.red };
            case "complete_red":
                return { label: "COMPLETE", style: classes.red };

        }
    };

    const { label, style } = type === "sub" ? getSubStatusDetails() : getStatusDetails();
    // sub tab sttaus action 


    const handleClick = (event) => {

        setOpen(true);
        setAnchorEl(event.currentTarget);

    };

    const handleCloseMenu = () => {
        setOpen(false);
        setAnchorEl(null);
        // setCurrentSelection({});
    };
    // this is called on status cancel
    const handleArchiveWorkshopOrder = async (name) => {
        if (rowDetails?.workshop_order_id === null)
            return handleCoreStatus(name);

        try {
            const response = await PartSalesServices.archiveWorkshopOrder(rowDetails?.workshop_order_id);
            if (response.success) {
                handleCoreStatus(name)
            }
            else {

                message.showToastMessage({
                    message: response.error ? response.error : "Something went wrong. Try again!",
                    variant: "error",
                });
            }
        } catch (error) {
            message.showToastMessage({
                message: "Something went wrong",
                variant: "error",
            });
        }

    }

    // this is called on status Reject /Repair
    const handleUnArchiveWorkshopOrder = async (name) => {
        if (rowDetails?.workshop_order_id === null)
            return handleCoreStatus(name);
        const formData = new FormData()
        formData.append("workshop_order_id", rowDetails?.workshop_order_id)
        try {
            const response = await PartSalesServices.unArchiveWorkshop(formData);
            if (response.success) {
                handleCoreStatus(name)
            }
            else {

                message.showToastMessage({
                    message: response.error || response.message || "Something went wrong. Try again!",
                    variant: "error",
                });
            }
        } catch (error) {
            message.showToastMessage({
                message: "Something went wrong",
                variant: "error",
            });
        }

    }



    const handleCoreStatus = (name) => {
        const formData = new FormData()
        formData.append("id", rowDetails?.id)
        formData.append("status", name)

        PartSalesServices.updateCoreStatus(formData).then((res) => {
            getDetails()
            message.showToastMessage({
                message: "Status updated successfully!",
                variant: "success",
            });
        }).catch((err) => {

        })

    }




    return (
        <>
            <Button variant="outlined" className={`${classes.button} ${style}`} style={{
                textDecoration: (type === "sub" && isEditable) ||
                    type !== "sub"
                    ? "underline"
                    : "none",
            }} onClick={(e) => {
                if (type === "sub" && isEditable) {
                    handleClick(e)
                } else if (type !== "sub") {
                    setAction("view")
                    setCurrentSelection(rowDetails)
                }
            }}>
                {label}
            </Button>
            {open && isEditable && <Menu
                id={`long-menu`}
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleCloseMenu}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ horizontal: "right" }}
                PaperProps={{
                    style: {
                        maxHeight: 48 * 5.5,
                        width: "12ch",
                        marginLeft: "67px",
                        marginTop: "-5px"
                    },
                }}

            ><>

                    {["pending", "overdue"].includes(status) && rowType === "External" && <>
                        {["Repair", "Cancel"].map((action) => (
                            <MenuItem
                                key={action}
                                style={{ fontSize: "12px" }}
                                onClick={() => {
                                    setOpen(false)
                                    if (action === "Cancel") {
                                        handleArchiveWorkshopOrder(action)
                                    } else {
                                        handleCoreStatus(action)
                                    }

                                }}
                            >
                                {action}
                            </MenuItem>
                        ))}
                    </>}



                    {["pending", "overdue"].includes(status) && rowType !== "External" && <MenuItem
                        // disabled={!props.permission.write && option !== "U/S label"}
                        key={"Cancel"}
                        style={{ fontSize: "12px" }}
                        onClick={() => {
                            setOpen(false)
                            handleArchiveWorkshopOrder("Cancel")
                        }}
                    >
                        Cancel
                    </MenuItem>}


                    {["repair"].includes(status) && <>
                        {["Reject", "Cancel", "Complete"].map((action) => (
                            <MenuItem
                                key={action}
                                style={{ fontSize: "12px" }}
                                onClick={() => {
                                    setOpen(false)
                                    if (action === "Cancel") {
                                        handleArchiveWorkshopOrder(action)
                                    } else {
                                        handleCoreStatus(action)
                                    }

                                }}
                            >
                                {action}
                            </MenuItem>
                        ))}
                    </>}
                    {(["cancelled"].includes(status) || isCompleteGreen) &&


                        <MenuItem
                            // disabled={!props.permission.write && option !== "U/S label"}
                            key={"Repair"}
                            style={{ fontSize: "12px" }}
                            onClick={() => {
                                setOpen(false)
                                handleUnArchiveWorkshopOrder("Repair")
                            }}
                        >
                            Repair
                        </MenuItem>}
                    {["rejected"].includes(status) && <>
                        {["Close", "Repair"].map((action) => (
                            <MenuItem
                                key={action}
                                style={{ fontSize: "12px" }}
                                onClick={() => {
                                    setOpen(false)
                                    if (action === "Close") {
                                        handleArchiveWorkshopOrder(action)
                                    } else {
                                        handleCoreStatus(action)
                                    }
                                }}
                            >
                                {action}
                            </MenuItem>
                        ))}
                    </>}
                    {isCompleteRed &&
                        <MenuItem
                            // disabled={!props.permission.write && option !== "U/S label"}
                            key={"Complete Reject"}
                            style={{ fontSize: "12px" }}
                            onClick={() => {
                                setOpen(false)
                                handleUnArchiveWorkshopOrder("Complete Reject")
                            }}
                        >
                            Reject
                        </MenuItem>}

                </>
            </Menu >}

        </>
    );
};

export default StatusButton;
